__turbopack_context__.v({
  "premiumValuePropsList": "styles-module__O5e4Ya__premiumValuePropsList",
});
